var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickenleg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 21.9963L9.90002 24.8963C10.3322 25.3987 10.5792 26.0339 10.6 26.6963C10.5741 27.3684 10.2888 28.0043 9.80402 28.4705C9.3192 28.9366 8.67258 29.1968 8 29.1963C7.33696 29.1963 6.70108 28.9329 6.23224 28.4641C5.7634 27.9952 5.5 27.3593 5.5 26.6963C4.83696 26.6963 4.20108 26.4329 3.73224 25.9641C3.2634 25.4952 3 24.8593 3 24.1963C2.9995 23.5237 3.25969 22.8771 3.72586 22.3923C4.19203 21.9075 4.82792 21.6222 5.5 21.5963C6.16236 21.6171 6.79762 21.8641 7.30002 22.2963L10.2 19.3963",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 21.9963L9.90002 24.8963C10.3322 25.3987 10.5792 26.0339 10.6 26.6963C10.5741 27.3684 10.2888 28.0043 9.80402 28.4705C9.3192 28.9366 8.67258 29.1968 8 29.1963C7.33696 29.1963 6.70108 28.9329 6.23224 28.4641C5.7634 27.9952 5.5 27.3593 5.5 26.6963C4.83696 26.6963 4.20108 26.4329 3.73224 25.9641C3.2634 25.4952 3 24.8593 3 24.1963C2.9995 23.5237 3.25969 22.8771 3.72586 22.3923C4.19203 21.9075 4.82792 21.6222 5.5 21.5963C6.16236 21.6171 6.79762 21.8641 7.30002 22.2963L10.2 19.3963",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2001 5.99628L27.7001 7.49628C28.6589 8.46919 29.1964 9.78033 29.1964 11.1463C29.1964 12.5123 28.6589 13.8233 27.7001 14.7963L27.1001 15.3963C24.3091 18.1203 20.8661 20.0828 17.1001 21.0963L12.9001 22.0963L11.5001 20.6963L10.1001 19.2963L11.2001 15.0963C12.1339 11.327 14.1091 7.89631 16.9001 5.19629L17.5001 4.49628C18.473 3.53747 19.7841 3 21.1501 3C22.5161 3 23.8272 3.53747 24.8001 4.49628L26.2001 5.99628Z",
    fill: "url(#paint0_linear_20_216)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_216",
    x1: 10.1665,
    y1: 5.96996,
    x2: 29.2231,
    y2: 22.0789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26702"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenleg);
export default __webpack_public_path__ + "static/media/chicken leg.0ebfa81b4fc7dfa19e2f300c6f71a4b6.svg";
export { ForwardRef as ReactComponent };